module.exports = __webpack_public_path__ + "img/1d205fd.png";